import React from 'react'

const OemLenders = () => {
  return (
    <section id="c-sectionOemLenders" className="c-sectionWrapper">
		<div className="container-fluid">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Multiple Lenders</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-6 col-md-12">						
						<p className="c-para22Regular">Oversee your existing lenders with FI-Men without any cost</p>
					</div>
				</div>
			</div>
			
			{/* <!-- <div className="c-oemLendersLogos">
				<div className="c-oemLendersLogo">
					<img src="images/mlender_hdf_bank.png" alt="" title="" />
				</div>
				<div className="c-oemLendersLogo">
					<img src="images/mlenders_icici_bank.png" alt="" title="" />
				</div>
				<div className="c-oemLendersLogo">
					<img src="images/mlenders_bob.png" alt="" title="" />
				</div>
				<div className="c-oemLendersLogo">
					<img src="images/mlenders_sbi.png" alt="" title="" />
				</div>
				<div className="c-oemLendersLogo">
					<img src="images/mlenders_idbi_bank.png" alt="" title="" />
				</div>
				<div className="c-oemLendersLogo">
					<img src="images/mlenders_union_bank.png" alt="" title="" />
				</div>
			</div> --> */}
		</div>	
		<div className="container c-mlendersSteps">
			<div className="row c-mlendersStep c-mlendersStep1">
				<div className="col-lg-6 col-md-5 col-sm-12 c-mlendersStepColImg">
					<img src="./images/oem/mlenders_self_financing.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-lg-6 col-md-7 col-sm-12 c-mlendersStepColInfo">
					<h5 className="c-mlendersStepTitle">Self financing Portal Available for the Dealers.</h5>
					{/* <!-- <p className="c-mlendersStepPara">Lorem Ipsum is simply dummy text of the printing and type Lorem Ipsum is simply dummy text.</p> --> */}
				</div>
			</div>
			<div className="row c-mlendersStep c-mlendersStep2">
				<div className="col-lg-6 col-md-5 col-sm-12 c-mlendersStepColImg">
					<img src="./images/oem/mlenders_asset_business_rule.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-lg-6 col-md-7 col-sm-12 c-mlendersStepColInfo">
					<h5 className="c-mlendersStepTitle">Asset Based Business Rule Engine</h5>
					{/* <!-- <p className="c-mlendersStepPara">Lorem Ipsum is simply dummy text of the printing and type Lorem Ipsum is simply dummy text.</p> --> */}
				</div>
			</div>
			<div className="row c-mlendersStep c-mlendersStep3">
				<div className="col-lg-6 col-md-5 col-sm-12 c-mlendersStepColImg">
					<img src="./images/oem/mlenders_single_financing.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-lg-6 col-md-7 col-sm-12 c-mlendersStepColInfo">
					<h5 className="c-mlendersStepTitle">Single financing agreement for multiple lenders</h5>
					{/* <!-- <p className="c-mlendersStepPara">Lorem Ipsum is simply dummy text of the printing and type Lorem Ipsum is simply dummy text.</p> --> */}
				</div>
			</div>
			<div className="row c-mlendersStep c-mlendersStep4">
				<div className="col-lg-6 col-md-5 col-sm-12 c-mlendersStepColImg">
					<img src="./images/oem/mlenders_master_admin.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-lg-6 col-md-7 col-sm-12 c-mlendersStepColInfo">
					<h5 className="c-mlendersStepTitle">Master Admin Available for OEM</h5>
					{/* <!-- <p className="c-mlendersStepPara">Lorem Ipsum is simply dummy text of the printing and type Lorem Ipsum is simply dummy text.</p> --> */}
				</div>
			</div>
		</div>	
	</section>
  )
}

export default OemLenders